const breev = (longName = '') => {
  return longName
    .split(' ')
    .map((word) => {
      // @ts-ignore
      return word ? word.split('')[0].toUpperCase() : '';
    })
    .join('')
    .trim();
};
export default breev;
